import { compose } from 'recompose';
import withStyling from './styling';

export default compose(withStyling);



// WEBPACK FOOTER //
// /opt/build/repo/src/app/connectors/index.js